import { useEffect, useState } from 'react'
import { Auth } from '@aws-amplify/auth'
import Cookies from 'js-cookie'

export const useAuthSession = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false)
  const [user, setUser] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(true)

  const COOKIE_OPTIONS = {
    expires: 7,
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'strict',
  }

  const setSessionCookie = async () => {
    try {
      const session = await Auth.currentSession()

      const sessionData = {
        token: session.getIdToken().getJwtToken(),
        refreshToken: session.getRefreshToken().getToken(),
        expiresAt: session.getIdToken().getExpiration() * 1000,
        userId: session.getIdToken().payload.sub,
        email: session.getIdToken().payload.email,
      }

      Cookies.set('userSession', JSON.stringify(sessionData), COOKIE_OPTIONS)
      setUser(sessionData)
      setIsAuthenticated(true)
      return sessionData
    } catch (error) {
      console.error('Error setting session:', error)
      await clearSession()
      return null
    }
  }

  const getSessionCookie = () => {
    const sessionCookie = Cookies.get('userSession')
    if (sessionCookie) {
      return JSON.parse(sessionCookie)
    }
    return null
  }

  const clearSession = async () => {
    try {
      await Auth.signOut()
    } catch (error) {
      console.error('Error signing out:', error)
    }
    Cookies.remove('userSession')
    setUser(null)
    setIsAuthenticated(false)
  }

  const isSessionExpired = () => {
    const session = getSessionCookie()
    if (!session) return true
    return Date.now() >= session.expiresAt
  }

  useEffect(() => {
    const initialiseSession = async () => {
      try {
        await Auth.currentAuthenticatedUser()
        await setSessionCookie()
      } catch (error) {
        await clearSession()
      } finally {
        setLoading(false)
      }
    }

    initialiseSession()
  }, [])

  return {
    isAuthenticated,
    user,
    loading,
    setSessionCookie,
    clearSession,
    getSessionCookie,
    isSessionExpired,
  }
}
